import { render, staticRenderFns } from "./LogoSignature4BrandsVideosSection.vue?vue&type=template&id=696e4751"
import script from "./LogoSignature4BrandsVideosSection.vue?vue&type=script&lang=ts"
export * from "./LogoSignature4BrandsVideosSection.vue?vue&type=script&lang=ts"
import style0 from "./LogoSignature4BrandsVideosSection.vue?vue&type=style&index=0&id=696e4751&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports